import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { I, Icon } from '../system/icons';
import { Row } from '../server/layout/Row/index';
import { Stack } from '../server/layout/Stack/index';
import { TONE } from '../system/tone';
import { Heading } from '../server/typography/Heading/Heading';
import { Body } from '../server/typography/Body/Body';
const SIZING = {
    page: { glyph: 64, glyphIcon: 26, titleLevel: 3, bodySize: 'md', padY: 64, padX: 40, maxBody: 460, gap: 'var(--space-lg)' },
    inset: { glyph: 56, glyphIcon: 24, titleLevel: 3, bodySize: 'md', padY: 48, padX: 32, maxBody: 420, gap: 'var(--space-lg)' },
    compact: { glyph: 44, glyphIcon: 20, titleLevel: 5, bodySize: 'sm', padY: 28, padX: 20, maxBody: 320, gap: 'var(--space-md)' },
};
const isMeaningfulReference = (s) => typeof s === 'string' && s.length > 0 && s.toUpperCase() !== 'UNKNOWN';
const titleStyle = { margin: 0, textWrap: 'pretty' };
const bodyStyle = { textWrap: 'pretty' };
const referenceStyle = { opacity: 0.7, marginTop: 'var(--space-xs)' };
const codeStyle = {
    fontFamily: "ui-monospace, 'Cascadia Code', 'Source Code Pro', Menlo, Consolas, monospace",
};
/**
 * Canonical inline error pattern for failed loads inside an authed page.
 * Full-page 4xx/5xx routes use a dedicated ErrorShell instead.
 */
export const ErrorState = ({ title, body, reference, density = 'inset', tone = 'burgundy', icon = 'alert', primary, secondary, actions, bordered = true, className, style, }) => {
    const sizing = SIZING[density];
    const t = TONE[tone];
    const showRef = isMeaningfulReference(reference);
    const hasActions = primary || secondary || actions;
    return (_jsxs("div", { role: "alert", className: className, style: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            textAlign: 'center',
            gap: sizing.gap,
            padding: `${sizing.padY}px ${sizing.padX}px`,
            // `bordered` renders the one shared module surface (--surface-module-*)
            // so a bordered ErrorState matches every Card; borderless stays flat
            // for when it sits inside a surface that already owns the frame.
            borderRadius: bordered ? 'var(--surface-module-radius)' : 0,
            border: bordered ? 'var(--surface-module-border)' : 'none',
            boxShadow: bordered ? 'var(--surface-module-shadow)' : 'none',
            background: bordered ? 'var(--surface-module-bg)' : 'transparent',
            ...style,
        }, children: [_jsx("div", { style: {
                    width: sizing.glyph,
                    height: sizing.glyph,
                    borderRadius: 'var(--radius-full)',
                    background: t.bg,
                    color: t.ink,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexShrink: 0,
                }, children: _jsx(Icon, { size: sizing.glyphIcon, children: I[icon] }) }), _jsxs(Stack, { gap: "sm", align: "center", style: { maxWidth: sizing.maxBody }, children: [_jsx(Heading, { level: sizing.titleLevel, style: titleStyle, children: title }), body ? (_jsx(Body, { as: "span", size: sizing.bodySize, color: "mute", style: bodyStyle, children: body })) : null, showRef ? (_jsxs(Body, { as: "span", size: "sm", color: "mute", style: referenceStyle, children: ["Reference ", _jsx("code", { style: codeStyle, children: reference })] })) : null] }), hasActions ? (_jsxs(Row, { gap: "sm", justify: "center", wrap: true, mt: "xs", style: { rowGap: 'var(--space-sm)' }, children: [primary, secondary, actions] })) : null] }));
};
//# sourceMappingURL=ErrorState.js.map